var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CustomSelect',{staticClass:"w-100",attrs:{"value":_vm.value,"label":"Location","placeholder":"Search by name, address, place id or store code","track-by":'id',"allow-empty":true,"values":_vm.locations},on:{"input":_vm.updateLocation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }